import Components from "../components";

// Bootstrap does not allow nested dropdown selectors. This class contains the
// functionality to show / hide the base dropdown & also updates the dynamic
// fault selection count.
class ActionsDropdown extends Components.Base {
  initialize() {
    this.$countText = this.$el.find(".actions-selected-count");
    this.$faultCountText = this.$el.find(".actions-selected-fault-count");
    this.$faultsField = this.$el.find("#fault_ids");
    this.queryResultSize = parseInt(this.el.dataset.resultCount, 10);
    this.idSet = new Set();
  }

  bind() {
    this.on("faultToggled", this.faultToggled.bind(this));
    this.on("addFaults", this.addFaults.bind(this));
    this.on("clearFaults", this.clearFaults.bind(this));
  }

  clearFaults() {
    this.idSet.clear();
    this.updateFaultCounts();
  }

  addFaults(_, { faultIds }) {
    faultIds.forEach((id) => this.idSet.add(id));
    this.updateFaultCounts();
  }

  faultToggled(_, { faultId }) {
    if (this.idSet.has(faultId)) {
      this.idSet.delete(faultId);
    } else {
      this.idSet.add(faultId);
    }

    this.updateFaultCounts();
  }

  updateFaultCounts() {
    const setSize = this.idSet.size;
    const faultStrFn = (size) => `${size} fault${size > 1 ? "s" : ""}`;

    if (setSize > 0) {
      this.$faultsField.attr("value", [...this.idSet].join(","));
      this.$countText.text(setSize);
      this.$faultCountText.text(faultStrFn(setSize));
    } else {
      this.$faultsField.removeAttr("value");
      this.$countText.text(this.queryResultSize);
      this.$faultCountText.text(faultStrFn(this.queryResultSize));
    }
  }
}

Components.collection.register({
  selector: ".c-actions-dropdown",
  klass: ActionsDropdown,
});
